import React from "react";
import SensorList from "./SensorList";

export default props => <SensorList {...props} />;
